module.exports = __webpack_public_path__ + "img/VillaLoreto_Room3.82acc54b.jpg";